// extracted by mini-css-extract-plugin
module.exports = {"calendarDayRow":"30"};